// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epU5Ow_EAs532iIg4RPw{flex-direction:column;gap:8px;width:532px;height:100%;margin:0 auto;display:flex}.epU5Ow_EAs532iIg4RPw .SYszeWqkLoUi1KzIhhtX{margin-left:-25px;overflow:auto}.HgcEYyEm2tAybmMm1goZ{border-radius:12px;width:492px;height:276px;margin-bottom:24px}.I3mLpDjhlKEIOQZlWuLV{margin-top:16px}.VDrKlACD_TsdGc7NFyu3{text-align:start}.q6kYwCa1cA9IrUq0qnrQ{margin-bottom:40px}.s_3Js5s5QM91q1gvekF_{margin:24px 20px 0}.CaVyfKx97ABEvNP1zpom{flex-direction:column;gap:4px;margin-left:4px;display:flex}.xp3CfaD5XHUToJtyUFHl{width:492px;margin:24px 0 30px 20px}.QE3zjQsZqQkyZPqro_FD{position:absolute;top:25px;right:20px}.aSUNV9DcqPsRYV95szlH{background:var(--gray-a-15);border-radius:4px;justify-content:center;align-items:center;gap:8px;width:68px;margin-top:32px;margin-left:20px;padding:3.5px 8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"questionsPageWrap": `epU5Ow_EAs532iIg4RPw`,
	"questionsBlock": `SYszeWqkLoUi1KzIhhtX`,
	"validateContentImg": `HgcEYyEm2tAybmMm1goZ`,
	"startNowButton": `I3mLpDjhlKEIOQZlWuLV`,
	"header": `VDrKlACD_TsdGc7NFyu3`,
	"firstQuestion": `q6kYwCa1cA9IrUq0qnrQ`,
	"alert": `s_3Js5s5QM91q1gvekF_`,
	"alertInfo": `CaVyfKx97ABEvNP1zpom`,
	"saveButton": `xp3CfaD5XHUToJtyUFHl`,
	"closeIcon": `QE3zjQsZqQkyZPqro_FD`,
	"titleStatus": `aSUNV9DcqPsRYV95szlH`
};
export default ___CSS_LOADER_EXPORT___;
